import { useTranslate } from "@tolgee/react";
import { Copy } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
import { useState } from "react";
import { toast } from "sonner";

export function StepTransferCrypto({ address }: { address?: string | null }) {
	const { t } = useTranslate();
	const [copied, setCopied] = useState(false);

	function handleCopy() {
		if (!address) return;
		navigator.clipboard.writeText(address);
		setCopied(true);
		setTimeout(() => setCopied(false), 1500);
		toast.success(t("actions.copied"));
	}

	return (
		<div className="flex flex-col gap-4">
			<div className="grid gap-3 sm:grid-cols-2">
				<div>
					<span className="text-caption1-medium text-trade-text-faint">
						{t("deposit.supported-token")}
					</span>
					<div className="mt-1.5 flex items-center gap-2 rounded-xl bg-trade-surface-inset px-3 py-2">
						<img
							src="https://sdk-cdn.fun.xyz/images/usdc.svg"
							width={24}
							height={24}
							alt="USDC"
						/>
						<span className="text-label1-bold text-trade-text-strong">
							USDC
						</span>
					</div>
				</div>

				<div>
					<span className="text-caption1-medium text-trade-text-faint">
						{t("deposit.supported-chain")}
					</span>
					<div className="mt-1.5 flex items-center gap-2 rounded-xl bg-trade-surface-inset px-3 py-2">
						<img
							src="https://sdk-cdn.fun.xyz/images/arbitrum.svg"
							width={24}
							height={24}
							alt="Arbitrum"
						/>
						<span className="text-label1-bold text-trade-text-strong">
							Arbitrum
						</span>
					</div>
				</div>
			</div>

			<div className="rounded-[18px] border border-trade-border-subtle bg-trade-surface-inset p-4 shadow-[inset_0_0_0_1px_rgba(255,255,255,0.02)]">
				{address && (
					<div className="flex justify-center pb-4">
						<div className="rounded-2xl bg-white p-3 shadow-[0_14px_28px_rgba(0,0,0,0.22)] transition-transform hover:scale-[1.02]">
							<QRCodeSVG
								value={`ethereum:${address}`}
								size={132}
								level="M"
								bgColor="#ffffff"
								fgColor="#000000"
							/>
						</div>
					</div>
				)}

				<div className="rounded-[14px] bg-trade-surface-inset px-3.5 py-3">
					<span className="text-caption1-medium uppercase text-trade-text-faint">
						{t("deposit.address-label")}
					</span>
					<div className="mt-2 flex items-center gap-3">
						<p className="min-w-0 flex-1 break-all text-label1-medium text-trade-text">
							{address ?? ""}
						</p>
						<button
							type="button"
							onClick={handleCopy}
							className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-trade-surface text-primary transition-colors hover:bg-trade-interactive cursor-pointer"
							aria-label={t("deposit.copy-address")}
						>
							<Copy className="h-3.5 w-3.5" />
						</button>
					</div>
				</div>
			</div>

			<button
				type="button"
				onClick={handleCopy}
				className="mx-auto inline-flex items-center gap-1.5 text-label1-bold text-primary transition-colors hover:text-primary/80 cursor-pointer"
			>
				<Copy className="h-3.5 w-3.5" />
				{copied ? t("actions.copied") : t("deposit.copy-address")}
			</button>
		</div>
	);
}
